<template>
  <div class="call-end-page" v-if="showCallEnd" ref="callEndPage">
    <div class="call-end-dialog" ref="callEndDialog">
      <img :src="wrapAvatar()" :onerror="errorAvatar"
           class="avatar">
      <div class="like-panel"></div>
      <div class="anchor-name" v-text="wrapName()">Alice Christina</div>
      <div :class="'content-panel '+(type==1?'comment':'')">
        <div class="unnormal-desc-panel" v-if="type!=1">Sorry, the call ended due to the host hanging up/poor network
          within 1 min. We
          will return your coins soon.
        </div>
        <div class="comment-panel" v-if="type==1">
          <div class="title-label">How do you feel about this call?</div>
          <div class="comment-tab-panel">
            <div :class="'comment-tab like '+(commentType==1?'active':'')" @click.stop="changeType(1)"></div>
            <div :class="'comment-tab dislike '+(commentType==2?'active':'')" @click.stop="changeType(2)"></div>
          </div>
          <div class="comment-label-panel">
            <div :class="'comment-label '+(commentIds.indexOf(item.id)!=-1?'active':'')"
                 v-for="(item,index) in commentDataList" @click.stop="chooseComment(commentType,item)"
                 v-text="item.label"></div>
          </div>
        </div>
      </div>
      <div class="action-panel" v-text="type==1?'Confirm':'Ok'" @click.stop="dealCallEnd"></div>
    </div>
  </div>
</template>

<script>
  import {isnull} from "../../utils/tools";
  import roomApi from "../../api/room-api";
  import icondefaulthead from '../../assets/imgs/icon_default_head.png';

  export default {
    name: "callenddialog",
    props: {
      showCallEnd: {
        type: Boolean,
        default: false
      },
      type: {
        type: Number,
        default: 1, //1-comment 2-unnormal
      },
      roomId: '',
      name: '',
      avatar: '',
      acc: ''
    },
    data() {
      return {
        commentType: 1, //1-like 2-unlike
        commentIds: [],
        upList: [
          {
            id: 1,
            label: 'Pretty Look'
          },
          {
            id: 2,
            label: 'Good Attitude'
          },
          {
            id: 3,
            label: 'Talkative'
          },
          {
            id: 4,
            label: 'Satisfying'
          },
          {
            id: 5,
            label: 'Attractive Voice'
          },
          {
            id: 6,
            label: 'Nice Figure'
          },
        ],
        dwnList: [
          {
            id: 1,
            label: 'Fake photos'
          },
          {
            id: 2,
            label: 'Bad Attitude'
          },
          {
            id: 3,
            label: 'Poor Languages'
          },
          {
            id: 4,
            label: 'Glitches(Black Screen)'
          },
          {
            id: 5,
            label: 'Bad Conditions(noisy/blurred)'
          },
          {
            id: 6,
            label: 'Others'
          },
        ],
        commentDataList: [],
        errorAvatar: 'this.src="' + icondefaulthead + '"',
      }
    },
    methods: {
      dealCallEnd() {
        if (this.type == 1) {
          this.doComment()
        } else {
          this.hideCEDialog()
        }
      },
      wrapAvatar() {
        return this.avatar
      },
      wrapName() {
        return this.name
      },
      changeType(type) {
        if (this.commentType != type) {
          this.commentType = type;
          this.commentIds = [];
          this.commentDataList = type == 1 ? this.upList : this.dwnList;
        }

      }
      ,
      chooseComment(type, data) {
        let index = this.commentIds.indexOf(data.id)
        if (index == -1)
          this.commentIds.push(data.id)
        else {
          this.commentIds.splice(index, 1)
        }
      }
      ,
      doComment() {
        if (!isnull(this.commentIds)) {
          let tags = {
            tag: this.commentIds
          }
          if (this.commentType == 1)
            roomApi.addCommentUpTags(this.acc, tags, null, null, this)
          else {
            roomApi.addCommentDownTags(this.acc, tags, null, null, this)
          }
        }
        roomApi.commentAnchor(this.acc, this.roomId, this.commentType, function (data, page) {
          page.hideCEDialog()
        }, function (code, msg, page) {

        }, this)
      },
      hideCEDialog() {
        this.$emit('hideCallEnd')
      },
      bodyCloseCallEndDialog(e) {
        let self = this;
        if (this.$refs.callEndDialog && !this.$refs.callEndDialog.contains(e.target)) {
          self.hideCallEndDialog();
        }
      },
    },
    watch: {
      showCallEnd(n, o) {
        if (n) {
          this.commentType = 1; //1-like 2-unlike
          this.commentIds = [];
          if (this.type == 1) {
            this.commentDataList = this.upList
          }
          //   setTimeout(function () {
          //     target.$refs.callEndPage.addEventListener("click", target.bodyCloseGameDialog);
          //   }, 100)
          //
          // } else {
          //   $('.page-container').css('overflow-y', 'auto')
          //   this.$refs.callEndPage.removeEventListener("click", this.bodyCloseCallEndDialog);
        }
      }
    }

  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .call-end-page {
    position: fixed;
    z-index: 5;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .3);

    .call-end-dialog {
      width: 100%;
      max-height: 80%;
      .minh(500);
      position: fixed;
      .b-radius(48, 48, 0, 0);
      background: #ffffff;
      bottom: 0;
      font-size: 0;

      .avatar {
        .w(240);
        .h(240);
        .b-radius(30);
        object-fit: cover;
        transform: translateY(-1.43rem);
      }

      .like-panel {
        .w(132);
        .h(132);
        margin-left: 50%;
        transform: translate(-50%, -2.43rem);
        background: url(../../assets/imgs/icon_followed.png) no-repeat;
        background-size: contain;
      }

      .like-panel.active {
        background: url(../../assets/imgs/icon_follow.png) no-repeat;
        background-size: contain;
      }

      .anchor-name {
        width: 100%;
        .fs(36);
        font-family: Gilroy-Bold;
        color: #333333;
        text-align: center;
        .lh(43);
        transform: translateY(-2.2rem);
      }

      .content-panel {
        width: 100%;
        max-height: 30%;
        overflow-y: auto;
        transform: translateY(-2rem);
        .mt(60);
        .mb(60);

        .unnormal-desc-panel {
          background: #f5f5f5;
          .b-radius(24);
          .ml(30);
          text-align: left;
          .mr(30);
          .padding(23, 30);
          .fs(32);
          color: #666666;
          font-family: Gilroy-Medium;
        }
      }

      .content-panel.comment {
        .mt(30);

        .comment-panel {
          .minh(500);
          width: 100%;

          .title-label {
            width: 100%;
            text-align: center;
            .fs(32);
            font-family: Gilroy-Medium;
            color: #000000;
            .lh(46);
            position: absolute;
          }

          .comment-tab-panel {
            .w(470);
            .h(96);
            display: flex;
            justify-content: space-between;
            position: absolute;
            .mt(70);
            left: 50%;
            transform: translateX(-50%);

            .comment-tab {
              .w(199);
              cursor: pointer;
              .h(96);
              display: inline-block;
            }

            .comment-tab.like {
              background: url(../../assets/imgs/like-tab.png) no-repeat;
              background-size: contain;
            }

            .comment-tab.active.like {
              background: url(../../assets/imgs/like-tab-active.png) no-repeat;
              background-size: contain;
            }

            .comment-tab.dislike {
              background: url(../../assets/imgs/unlike-tab.png) no-repeat;
              background-size: contain;
            }

            .comment-tab.active.dislike {
              background: url(../../assets/imgs/unlike-tab-active.png) no-repeat;
              background-size: contain;
            }
          }

          .comment-label-panel {
            .w(750);
            left: 50%;
            transform: translateX(-50%);
            .mt(180);
            position: absolute;

            .comment-label {
              .mt(30);
              .ml(30);
              .w(322);
              .h(68);
              float: left;
              .b-radius(38);
              .border(4, solid, rgba(187, 195, 206, 0.4));
              background: #fff;
              .fs(28);
              font-family: Gilroy-Medium;
              color: #9AA3AF;
              .lh(68);
              white-space: nowrap;
              text-overflow: ellipsis;
              max-lines: 1;
              overflow: hidden;
            }

            .comment-label.active {
              .border(4, solid, #FF0E74);
              background: #FF0E74;
              .fs(28);
              font-family: Gilroy-Medium;
              color: #fff;
              .lh(68);
            }
          }
        }
      }

      .action-panel {
        .b-radius(38);
        .w(690);
        .h(116);
        .lh(116);
        .b-radius(36);
        text-align: center;
        position: absolute;
        .btm(25);
        left: 50%;
        transform: translateX(-50%);
        background: #ff0e74;
        .b-radius(36);
        .fs(36);
        font-family: Gilroy-Bold;
        color: #ffffff;

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/callenddialog.vue